import type { Messages } from './en';

const ru: Partial<Messages> = {
  'lang.label': 'Язык',
  'nav.tracker': 'Отслеживание заказа',
  'nav.robux': 'Заказ Robux',
  'common.loading': 'Загрузка вашего заказа…',
  'common.order': 'Заказ #{id}',
  'common.submit': 'Отправить',

  'landing.title': 'Отследите свой заказ',
  'landing.sub': 'Введите номер заказа, чтобы видеть статус доставки в реальном времени',
  'landing.header': 'Номер вашего заказа',
  'landing.label': 'Номер заказа',
  'landing.placeholder': 'Введите номер заказа',
  'landing.btn': 'Отследить заказ',

  'terms.title': 'Прежде чем продолжить',
  'terms.intro': 'Пожалуйста, прочитайте и примите пункты ниже, чтобы продолжить оформление заказа.',
  'terms.p1': '<b>Вы отвечаете за аккаунт, который вводите.</b> Как только аккаунт попадает в нашу систему, перевод идёт автоматически, поэтому убедитесь, что аккаунт верный — потом перенаправить монеты мы не сможем.',
  'terms.p2': '<b>Весь процесс автоматический.</b> Его скорость, быстрая или медленная, не регулируется и не контролируется — наша система синхронизирована с системой обнаружения EA: она продолжает работу, пока процесс считается безопасным, и останавливается, когда это не так.',
  'terms.p3': '<b>Мы не покрываем налог EA ({pct}%).</b> Вы заказали {gross}K монет, поэтому получите <b>{net}K монет</b> чистыми.',
  'terms.p4': '<b>Если возникнет проблема с переводом, сначала обратитесь к сотруднику, который ведёт ваш заказ.</b> Не открывайте спор сразу — это не ускоряет решение, а только усложняет его.',
  'terms.agree': 'Я прочитал(а) всё вышеизложенное и согласен(на)',
  'terms.accept': 'Согласен(на) — продолжить',
  'terms.decline': 'Не согласен(на)',
  'terms.declinedTitle': 'Без проблем',
  'terms.declinedBody': 'Ничего страшного — на вашем аккаунте ничего не запускалось. Если какой-то пункт непонятен, спросите сотрудника, который ведёт ваш заказ. Вы можете вернуться на эту страницу и продолжить, когда будете готовы.',
  'terms.back': 'Назад',

  'tax.hero': 'Куплено {gross}K · в ваш клуб поступит {net}K',
  'tax.noteTitle': 'EA удерживает {pct}% с каждой продажи монет',
  'tax.noteBody': 'Вы купили <b>{gross}K монет</b>. Налог EA в размере {pct}% мы не покрываем, поэтому в ваш клуб поступит <b>{net}K монет</b> — именно эту сумму покрывает ваш заказ.',
  'tax.finished': 'В ваш клуб поступило <b>{net}K монет</b> (куплено {gross}K за вычетом налога EA {pct}%).',

  'hero.loading': 'Загрузка…',
  'hero.notFound': 'Заказ не найден',
  'hero.unknown': 'Неизвестно',
  'hero.cancelled': 'Заказ отменён',
  'hero.awaiting': 'Ожидаем ваши данные',
  'hero.delivered': 'Успешно доставлено!',
  'hero.dailyLimit': 'Достигнут дневной лимит',
  'hero.no2fa': 'Включите подтверждение входа',
  'hero.newBA': 'Нужен новый резервный код',
  'hero.wrongPass': 'Неверные данные для входа',
  'hero.processing': 'Обработка',
  'hero.paused': 'Заказ приостановлен',
  'hero.delivering': 'Доставка ваших монет',
  'badge.cancelled': 'ОТМЕНЁН',
  'badge.action': 'ТРЕБУЕТСЯ ДЕЙСТВИЕ',
  'badge.complete': 'ЗАВЕРШЁН',
  'badge.autoResume': 'ВОЗОБНОВИТСЯ ЗАВТРА',
  'badge.support': 'СВЯЖИТЕСЬ С ПОДДЕРЖКОЙ',
  'badge.retry': 'АВТОПОВТОР',
  'badge.progress': 'В ПРОЦЕССЕ',
  'hero.pct': 'Доставлено {pct}% · {delivered}K из {ordered}K монет',
  'hero.refresh': 'Обновить',

  'msg.notFound': 'Заказ не найден',
  'msg.netRetry': 'Ошибка сети — повторяем…',
  'msg.submitFail': 'Не удалось отправить. Попробуйте ещё раз.',
  'msg.net': 'Ошибка сети. Попробуйте ещё раз.',
  'msg.resumed': 'Заказ возобновлён! Обновляем статус…',
  'msg.waitLogout': 'Подождите немного после выхода из аккаунта и попробуйте снова.',
  'msg.cantResumeWhy': 'Пока нельзя возобновить — {reason}. Заказ возобновится автоматически.',
  'msg.cantResume': 'Пока нельзя возобновить — заказ возобновится автоматически. Попробуйте чуть позже.',
  'msg.resumeFail': 'Не удалось возобновить. Свяжитесь с поддержкой.',
  'msg.retrying': 'Повторяем попытку! Обновляем статус…',
  'msg.retryFail': 'Повторная попытка не удалась — попробуйте чуть позже.',
  'msg.cancelledTitle': 'Этот заказ был отменён.',
  'msg.cancelledBody': 'Свяжитесь с человеком, который оформлял ваш заказ, если считаете, что это ошибка.',

  'pending.banner': 'Ваш заказ на <b>{amount}K монет</b> для <b>{platform}</b> готов. Введите ниже данные аккаунта EA, чтобы начать доставку. Данные передаются безопасно и нигде не хранятся.',
  'pending.header': 'Данные вашего аккаунта EA',
  'pending.logout': '<b>Перед отправкой:</b> выйдите из приложения EA, FUT Web App и сопутствующего приложения на всех устройствах.',
  'pending.email': 'Эл. почта аккаунта EA',
  'pending.emailPh': 'ваш@email.com',
  'pending.password': 'Пароль аккаунта EA',
  'pending.passwordPh': 'Ваш пароль EA',
  'pending.ba1': 'Резервный код №1',
  'pending.ba1Hint': '— из настроек безопасности EA',
  'pending.ba1Ph': 'напр. 12345678',
  'pending.ba2': 'Резервный код №2',
  'pending.ba3': 'Резервный код №3',
  'pending.optional': '— необязательно',
  'pending.hideExtra': '− Скрыть дополнительные коды',
  'pending.showExtra': '+ Добавить ещё резервные коды (рекомендуется)',
  'pending.start': 'Начать доставку',
  'pending.starting': 'Запуск доставки…',
  'pending.locked': 'Прочитайте и примите условия, чтобы продолжить.',
  'pending.reopenTerms': 'Перечитать условия',

  'active.delivered': 'Ваши монеты доставлены! ⚽',
  'active.thanks': 'Спасибо, что выбрали 911GamingStore. Приятной игры!',
  'active.stayOut': '<b>Оставайтесь вне аккаунта</b> в приложении EA, FUT Web App и сопутствующем приложении на всех устройствах, пока заказ выполняется.',
  'active.meta': ' · ~10 мин на 100K · Дневной лимит: 1–3 млн монет (на следующий день продолжится автоматически)',
  'active.dailyHeader': 'Достигнут дневной лимит переводов',
  'active.dailyBody': 'Дневной лимит переводов на сегодня исчерпан. Это обычная защита — заказ автоматически возобновится завтра. От вас ничего не требуется. Вы можете входить в игру, играть как обычно и даже тратить монеты — заказ возобновится сам примерно через 30 часов. Оставшееся время можно проверить кнопкой ниже. Спасибо за терпение 👍',
  'active.retryBtn': 'Я исправил(а) — повторить',
  'active.retrying': 'Повторяем…',
  'metric.ordered': 'Заказано',
  'metric.willReceive': 'Вы получите',
  'metric.delivered': 'Доставлено',
  'metric.remaining': 'Осталось',
  'progress.title': 'Ход доставки',
  'progress.starting': 'Запуск…',
  'progress.inProgress': 'В процессе',
  'progress.complete': 'Завершено',

  'ba.titleNo2fa': 'Включите подтверждение входа и введите резервный код',
  'ba.titleNew': 'Нужен новый резервный код',
  'ba.descNo2fa': 'На вашем аккаунте EA не настроено подтверждение входа. Сначала включите его, затем создайте резервные коды и введите один из них ниже:',
  'ba.descNew': 'Ваш резервный код неверен или устарел. Выполните шаги ниже и введите новый код:',
  'ba.no2faSteps': 'Откройте <b>account.ea.com</b> → Безопасность → Подтверждение входа\nВключите подтверждение — выберите приложение-аутентификатор или эл. почту\nПосле включения перейдите в <b>Резервные коды</b> и создайте новый набор\nСкопируйте один из новых кодов и введите его ниже',
  'ba.newSteps': 'Откройте <b>account.ea.com</b> → Безопасность → Подтверждение входа → Резервные коды\nСоздайте новый набор резервных кодов\nСкопируйте один из новых кодов и введите его ниже',
  'ba.placeholder': 'Новый резервный код',
  'ba.ok': 'Резервный код обновлён! Повторяем заказ…',
  'ba.fail': 'Не удалось. Проверьте код или свяжитесь с поддержкой.',
  'cred.title': 'Обновите данные для входа',
  'cred.desc': 'Похоже, почта или пароль изменились. Проверьте и обновите данные ниже:',
  'cred.steps': 'Откройте <b>account.ea.com</b> и убедитесь, что почта и пароль верны\nЕсли вы недавно меняли пароль, введите новый ниже\nПеред отправкой убедитесь, что вы вышли из всех приложений EA',
  'cred.emailPh': 'Почта аккаунта EA (если изменилась)',
  'cred.passPh': 'Новый пароль аккаунта EA',
  'cred.ok': 'Данные обновлены! Повторяем заказ…',
  'cred.fail': 'Не удалось обновить. Свяжитесь с поддержкой.',
  'resume.title': 'Заказ приостановлен — возобновите, когда будете готовы',
  'resume.desc': 'Ваш заказ приостановлен. Убедитесь, что вы вышли из всех приложений EA, и нажмите «Возобновить».',
  'resume.btn': 'Возобновить заказ',
  'resume.busy': 'Возобновляем…',
  'cool.title': 'Проверить оставшееся время',
  'cool.btn': 'Проверить ожидание',
  'cool.busy': 'Проверяем…',
  'cool.desc': 'Узнайте, сколько осталось до сброса дневного лимита переводов и автоматического возобновления заказа.',
  'cool.ready': 'Лимит сброшен! Заказ скоро возобновится.',
  'cool.hm': 'Осталось примерно {h} ч {m} мин',
  'cool.min': 'Осталось примерно {m} мин',
  'shot.before': 'Подтверждение аккаунта (до)',
  'shot.latest': 'Последнее подтверждение перевода',
  'shot.none': 'Пока недоступно',
  'row.status': 'Статус',
  'row.accountCheck': 'Проверка аккаунта',
  'row.economy': 'Состояние экономики',
  'row.balance': 'Баланс аккаунта',
  'row.created': 'Заказ создан',
  'row.coins': '{n} монет',


  // ── Shop with us (replaces the old promo) + footer ─────────
  'shop.eyebrow': 'Больше, чем монеты FC',
  'shop.title': 'Всё, во что вы играете. В одном магазине.',
  'shop.lede': 'Пополнение игр, подарочные карты и игровые ключи по понятным низким ценам — автоматическая доставка 24/7.',
  'shop.from': 'От {price}',
  'shop.floor': 'Цены от {price}',
  'shop.browse': 'Смотреть всё',
  'shop.cta': 'Купить в 911 Gaming Store',
  'shop.pay': 'Оплата',
  'shop.f1t': 'Низкие и понятные цены',
  'shop.f1d': 'Полная цена видна до оплаты — без сюрпризов.',
  'shop.f2t': 'Автоматическая доставка',
  'shop.f2d': 'Большинство заказов приходят сами — днём и ночью.',
  'shop.f3t': 'Безопасность аккаунта прежде всего',
  'shop.f3d': 'Ваши данные для входа никогда не хранятся.',
  'shop.f4t': 'Настоящая поддержка 24/7',
  'shop.f4d': 'Люди, а не боты — с вами, пока заказ не выполнен.',
  'shop.cat.game-top-ups': 'Пополнение игр',
  'shop.cat.gift-cards': 'Подарочные карты',
  'shop.cat.game-keys': 'Игровые ключи',
  'footer.desc': 'Пополнение игр, подарочные карты и игровые ключи с понятными ценами, быстрой доставкой и настоящей службой поддержки, которая с вами, пока каждый заказ не выполнен.',
  'footer.shop': 'Магазин',
  'footer.help': 'Помощь',
  'footer.track': 'Отследить заказ',
  'footer.contact': 'Связаться с поддержкой',

  'err.wrongPersona.t': 'Выбрана не та персона',
  'err.wrongPersona.d': 'В вашем аккаунте выбрана неверная персона FUT.',
  'err.wrongPersona.s': 'Откройте FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nНажмите на значок профиля и переключитесь на нужную персону FUT\nПолностью выйдите из аккаунта на всех устройствах и в браузерах',
  'err.captcha.t': 'Требуется проверка CAPTCHA',
  'err.captcha.d': 'EA запрашивает проверку безопасности вашего аккаунта.',
  'err.captcha.s': 'Откройте FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nВойдите и пройдите CAPTCHA, если она появится\nПолностью выйдите из аккаунта',
  'err.wrongUserPass.t': 'Неверные данные для входа',
  'err.wrongUserPass.d': 'Введённые почта или пароль неверны либо изменились после отправки.',
  'err.wrongUserPass.s': 'Проверьте, что почта и пароль аккаунта EA по-прежнему верны\nПри необходимости сбросьте пароль на account.ea.com\nСообщите человеку, оформлявшему заказ, чтобы он обновил ваши данные',
  'err.wrongBA.t': 'Неверный резервный код',
  'err.wrongBA.d': 'Резервный код неверен или уже использован.',
  'err.wrongBA.s': 'Откройте account.ea.com → Безопасность → Подтверждение входа → Резервные коды\nСоздайте новый набор резервных кодов\nВведите один из новых кодов в форму ниже',
  'err.No2FA.t': 'Подтверждение входа (2FA) не настроено',
  'err.No2FA.d': 'На вашем аккаунте EA не включено подтверждение входа. Оно необходимо для работы перевода.',
  'err.No2FA.s': 'Откройте account.ea.com → Безопасность → Подтверждение входа\nВключите подтверждение — выберите приложение-аутентификатор или эл. почту\nПосле включения откройте «Резервные коды» и создайте новый набор\nВведите один из новых кодов в форму ниже',
  'err.noTM.t': 'Нет доступа к трансферному рынку Web App',
  'err.noTM.d': 'Этот аккаунт EA не может использовать трансферный рынок в FUT Web App. Это не трансферный рынок внутри игры — они отдельные, поэтому в игре он может работать, а в Web App оставаться заблокированным.',
  'err.noTM.s': 'Откройте FUT Web App на www.ea.com/fifa/ultimate-team/web-app и перейдите в Transfers → Transfer Market\nЕсли он заблокирован или недоступен, пройдите обучение FUT и продолжайте играть матчи, пока EA не откроет его для вашего аккаунта\nПри необходимости проверьте, что подписка EA Play / EA Pro активна\nВаш заказ остаётся открытым — когда трансферный рынок Web App заработает, сообщите человеку, оформлявшему заказ, и перевод продолжится',
  'err.tlFull.t': 'Список трансферов заполнен',
  'err.tlFull.d': 'Ваш список трансферов FUT заполнен и блокирует новые переводы.',
  'err.tlFull.s': 'Откройте FUT Web App или приложение EA на телефоне\nПерейдите в Трансферы → Список трансферов\nПродайте или удалите предметы, освободив не менее 5 слотов\nПолностью выйдите из аккаунта',
  'err.receiverTLFull.t': 'Ваш список трансферов заполнен',
  'err.receiverTLFull.d': 'В вашем списке трансферов нет места — монеты нельзя отправить, пока вы не освободите слоты.',
  'err.receiverTLFull.s': 'Откройте FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nПерейдите в Трансферы → Список трансферов\nПродайте или быстро продайте предметы, освободив не менее 5 слотов\nПолностью выйдите из всех приложений и браузеров EA',
  'err.FailedReceiverDeviceBan.t': 'Ваш аккаунт отмечен EA',
  'err.FailedReceiverDeviceBan.d': 'EA наложила на ваш аккаунт блокировку на уровне устройства. Требуется вмешательство.',
  'err.FailedReceiverDeviceBan.s': 'Не входите в аккаунт EA — немедленно сообщите человеку, оформлявшему заказ',
  'err.FailWebAppNotYetUnlocked.t': 'FUT Web App ещё не разблокирован',
  'err.FailWebAppNotYetUnlocked.d': 'Ваш аккаунт EA ещё не разблокировал FUT Web App, необходимый для переводов.',
  'err.FailWebAppNotYetUnlocked.s': 'Откройте FIFA/EA FC на консоли или ПК\nПройдите обучение FUT и сыграйте хотя бы несколько матчей\nКогда FUT Web App станет доступен, сообщите человеку, оформлявшему заказ',
  'err.FailWebAppCustomerLocked.t': 'Ваш сеанс FUT Web App заблокирован',
  'err.FailWebAppCustomerLocked.d': 'Веб-сеанс вашего аккаунта EA заблокирован — обычно из-за входа на другом устройстве.',
  'err.FailWebAppCustomerLocked.s': 'Выйдите из FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nВыйдите из приложения EA на телефоне и других устройствах\nПодождите 5 минут и попробуйте снова',
  'err.calcErrorMaintenance.t': 'Временные технические работы EA',
  'err.calcErrorMaintenance.d': 'У EA идут технические работы — повторяем автоматически. Действий не требуется.',
  'err.noPlayer.t': 'Подбираем подходящий перевод (повтор)',
  'err.noPlayer.d': 'Сейчас нет подходящей карточки игрока — повторяем автоматически.',
  'err.safetyHold.t': 'Ожидаем безопасное окно для перевода',
  'err.safetyHold.d': 'Наша система определяет, когда система мониторинга переводов EA активна и отслеживает движение монет по всему рынку. Сейчас она показывает повышенную активность, поэтому мы приостановили ваш перевод ради безопасности. Это касается всего рынка, а не вашего аккаунта. Как только система EA успокоится, ваш заказ продолжится автоматически. От вас ничего не требуется.',
  'err.belowMinTransfer.t': 'Перевод меньше минимума',
  'err.belowMinTransfer.d': 'Оставшаяся сумма меньше минимального порога перевода. Вы можете возобновить заказ и продолжить меньшим переводом.',
  'err.belowMinTransfer.s': 'Нажмите «Возобновить» ниже, чтобы продолжить доставку на оставшуюся сумму',
  'err.notEnoughCoins.t': 'На аккаунте недостаточно монет',
  'err.notEnoughCoins.d': 'Для обработки переводов на аккаунте должно быть не менее 10 000 монет.',
  'err.notEnoughCoins.s': 'Купите любого дешёвого игрока на трансферном рынке, чтобы на аккаунте появились монеты\nКогда у вас будет не менее 10 000 монет, нажмите «Повторить» ниже',
  'err.unassignedItemsPresent.t': 'Есть неназначенные предметы',
  'err.unassignedItemsPresent.d': 'В вашем аккаунте есть предметы, которые нужно назначить, чтобы переводы могли продолжиться.',
  'err.unassignedItemsPresent.s': 'Откройте FUT Web App или приложение EA\nПерейдите в Клуб → Неназначенные предметы\nПереместите все предметы в клуб или в список трансферов\nПолностью выйдите из аккаунта',
  'err.console.t': 'Вы всё ещё в Ultimate Team на консоли',
  'err.console.d': 'Ваш аккаунт активен в Ultimate Team на PlayStation или Xbox.',
  'err.console.s': 'На консоли откройте FIFA/EA FC и зайдите в Ultimate Team\nНажмите Options/Start → Выйти в главное меню (не просто закрывайте игру)\nДождитесь полного выхода игры из Ultimate Team',
  'err.loginFailed.t': 'Не удалось войти — выйдите отовсюду',
  'err.loginFailed.d': 'EA отклонила вход, скорее всего потому, что ваш аккаунт активен на другом устройстве или в браузере.',
  'err.loginFailed.s': 'Выйдите из приложения EA на всех телефонах и планшетах\nВыйдите из FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nВыйдите из сопутствующего приложения FIFA/FC, если пользуетесь им',
  'err.LoginFailedDeviceBan.t': 'Вход заблокирован EA',
  'err.LoginFailedDeviceBan.d': 'EA заблокировала вход из нашей системы. Требуются действия нашей команды.',
  'err.LoginFailedDeviceBan.s': 'Не входите в аккаунт EA самостоятельно — немедленно сообщите человеку, оформлявшему заказ',
  'err.FailedSessionExpiredCustomerLoggedIn.t': 'Вы сейчас вошли в приложение EA',
  'err.FailedSessionExpiredCustomerLoggedIn.d': 'Ваш аккаунт активен в приложении EA или в вебе на другом устройстве.',
  'err.FailedSessionExpiredCustomerLoggedIn.s': 'Выйдите из FUT Web App на www.ea.com/fifa/ultimate-team/web-app\nВыйдите из приложения EA на телефоне\nВыйдите из сопутствующего приложения FIFA/FC',
  'err.FailLoggedInConsoleTo.t': 'Вы сейчас вошли в приложение EA',
  'err.FailLoggedInConsoleTo.d': 'Ваш аккаунт активен на другом устройстве или в браузере.',
  'err.FailLoggedInConsoleTo.s': 'Выйдите из FUT Web App и приложения EA на всех устройствах',
  'err.FailedProxyConnectionError.t': 'Временная техническая неполадка',
  'err.FailedProxyConnectionError.d': 'Кратковременная неполадка с нашей стороны — повторяем автоматически. Действий не требуется.',
  'err.FailedProxyPoolExhausted.t': 'Временная проблема с сетью',
  'err.FailedProxyPoolExhausted.d': 'Кратковременная сетевая проблема с нашей стороны — повторяем автоматически. Действий не требуется.',
  'err.FailedCouldNotStartTo.t': 'Запуск перевода (повтор)',
  'err.FailedCouldNotStartTo.d': 'Кратковременная проблема при запуске перевода — повторяем автоматически.',
  'err.noClub.t': 'Клуб FUT не найден',
  'err.noClub.d': 'У вашего аккаунта EA нет активного клуба FUT — без него монеты получить нельзя.',
  'err.noClub.s': 'Откройте FIFA/EA FC и запустите Ultimate Team\nЗавершите начальную настройку FUT и сыграйте хотя бы один матч\nКогда клуб FUT будет готов, сообщите человеку, оформлявшему заказ',
  'err.wrongConsole.t': 'Платформа не совпадает',
  'err.wrongConsole.d': 'Платформа в вашем заказе не совпадает с аккаунтом EA.',
  'err.wrongConsole.s': 'Сообщите человеку, оформлявшему заказ, — ему нужно исправить платформу',
  'err.daily.t': 'Достигнут дневной лимит переводов',
  'err.senderTempban.t': 'Поставщик временно приостановлен',
  'err.senderTempban.d': 'У нашего аккаунта поставщика короткая пауза от EA. Это решается автоматически — действий не требуется.',
  'err.transfersInProgress.t': 'Перевод выполняется',
  'err.transfersInProgress.d': 'Переводы обрабатываются — скоро обновится.',

  'status.pending': 'Ожидает',
  'status.ready': 'Готов',
  'status.entered': 'Данные введены',
  'status.waitingForAssignment': 'Ожидает назначения',
  'status.active': 'Активен',
  'status.finished': 'Завершён',
  'status.interrupted': 'Прерван',
  'status.tempbanCooldown': 'Ожидание',
  'status.cancelled': 'Отменён',
  'status.completed': 'Выполнен',

  'rbx.heroLine': 'Game pass на {gross} R$ · до вас дойдёт {net} R$',
  'rbx.hero.pass': 'Отправьте ваш game pass',
  'rbx.hero.done': 'Robux доставлены!',
  'rbx.hero.delivering': 'Доставка ваших Robux',
  'rbx.hero.retrying': 'Повтор',
  'rbx.notFoundTitle': 'Мы не нашли этот заказ',
  'rbx.createTitle': 'Создайте game pass на {gross} R$',
  'rbx.taxIntro': 'Roblox удерживает {pct}% с каждой продажи game pass, поэтому pass за <b>{gross} R$</b> приносит <b>{net} R$</b> — именно эта сумма поступит на ваш аккаунт, и именно её покрывает ваш заказ.',
  'rbx.steps': 'Откройте Roblox → <b>Create</b> → выберите любую свою игру\nПерейдите в <b>Associated Items → Passes</b> и создайте pass\nОткройте pass → <b>Configure → Sales</b>\nВключите <b>Item for Sale</b> и установите цену ровно <b>{gross} R$</b>\nОтправьте ниже — ссылку на pass, только его ID или ваше имя пользователя Roblox',
  'rbx.reqTitle': 'Ваш game pass также должен соответствовать этим правилам',
  'rbx.req': '<b>Managed / Regional Pricing</b> должен быть выключен (OFF)\nВ анкете возрастной оценки контента ответьте <b>No</b> на все вопросы\nИгра должна быть <b>Public</b> (если скрыта: Archive → Restore → Make Public)\nВаш аккаунт Roblox должен быть с <b>подтверждённым возрастом (16+)</b>',
  'rbx.videoBtn': 'Не знаете, как создать game pass? Посмотрите видеоинструкцию',
  'rbx.tabPass': 'Ссылка или ID pass',
  'rbx.tabUser': 'Имя пользователя Roblox',
  'rbx.passLabel': 'Ссылка или ID game pass',
  'rbx.passPh': 'https://www.roblox.com/game-pass/000000000/…  или просто 000000000',
  'rbx.reading': 'Читаем game pass <b>#{id}</b> ✓',
  'rbx.badPaste': 'Пока не похоже на ссылку или ID game pass — вставьте ссылку целиком или только цифры из неё.',
  'rbx.userLabel': 'Имя пользователя Roblox',
  'rbx.userPh': 'Аккаунт, который получит Robux',
  'rbx.userHint': 'Мы сами найдём pass на вашем аккаунте. Его цена всё равно должна быть ровно <b>{gross} R$</b>, он должен быть в продаже и находиться в одной из ваших публичных игр.',
  'rbx.placeLabel': 'ID игры / плейса',
  'rbx.placePh': 'Только если у вас больше одной игры',
  'rbx.sendPass': 'Отправить мой game pass',
  'rbx.sendUser': 'Отправить моё имя пользователя',
  'rbx.sending': 'Отправка…',
  'rbx.allSet': 'Всё готово — больше ничего делать не нужно',
  'rbx.sentDone': '<b>{net} R$</b> отправлено на ваш аккаунт Roblox{user}.',
  'rbx.sentWait': 'Ваш game pass у нас, и заказ с нашей стороны выполнен. <b>{net} R$</b> уже в пути на ваш аккаунт Roblox.',
  'rbx.holdTitle': 'Почему тратить Robux можно только через 5–7 дней',
  'rbx.holdBody1': 'Roblox удерживает доход от <em>каждой</em> продажи game pass в течение периода ожидания, прежде чем им можно пользоваться. Ваши Robux сначала отобразятся как <b>ожидающие</b>, а затем станут доступны в течение <b>5–7 дней</b>.',
  'rbx.holdBody2': 'Так Roblox работает со всеми покупками game pass — ни мы, ни кто-либо другой не может это ускорить. Ваш заказ выполнен.',
  'rbx.favourTitle': 'Небольшая просьба',
  'rbx.favourBody': 'Если всё в порядке, отметьте заказ на Eldorado как <b>полученный</b> и оставьте отзыв. Мы небольшая команда, и для нас это действительно важно. 🙏',
  'rbx.eldoradoBtn': 'Подтвердить и оставить отзыв на Eldorado',
  'rbx.passOnFile': 'Сохранённый game pass:',
  'rbx.passLabelShort': 'Game pass:',
  'rbx.providerDown': 'Статус в реальном времени ненадолго недоступен — на ваш заказ это не влияет.',
  'rbx.tryAgain': 'Повторить',
  'rbx.retrying': 'Повторяем…',
  'rbx.cancelledTitle': 'Этот заказ отменён',
  'rbx.cancelledBody': 'Свяжитесь с человеком, который оформлял ваш заказ, если считаете, что это ошибка.',
  'rbx.msg.noAccept': 'Не удалось принять эту ссылку',
  'rbx.msg.net': 'Не удалось связаться с сервером. Проверьте подключение.',
  'rbx.msg.retryWait': 'Пока нельзя повторить — попробуйте через минуту.',
  'rbx.msg.retryOk': 'Повторяем — страница обновится сама.',

  'rbxi.gamepass_not_found.t': 'Мы пока не видим ваш game pass',
  'rbxi.gamepass_not_found.d': 'Roblox не опубликовал pass, либо он был удалён или переименован после отправки ссылки. Мы продолжаем проверять сами — только что созданный pass обычно находится в течение нескольких минут.',
  'rbxi.gamepass_not_found.s': 'Откройте страницу вашего game pass и убедитесь, что он существует\nУбедитесь, что цена ровно такая, как указано выше\nПроверьте, что pass в продаже (On Sale)\nЗатем нажмите «Повторить» ниже',
  'rbxi.insufficient_customer_balance.t': 'Ваш заказ в очереди',
  'rbxi.insufficient_customer_balance.d': 'Мы пополняем баланс, и заказ пройдёт автоматически. От вас ничего не требуется.',
  'rbxi.unknown_error.t': 'Вашему заказу нужна ещё одна попытка',
  'rbxi.unknown_error.d': 'Что-то прервало доставку. Мы повторяем попытки автоматически — вы также можете запустить повтор сами.',
  'rbxi.GAMEPASS_NOT_FOUND.t': 'Этот game pass не найден',
  'rbxi.GAMEPASS_NOT_FOUND.d': 'По этой ссылке в Roblox нет pass. Только что созданным pass может понадобиться минута, чтобы появиться.',
  'rbxi.GAMEPASS_NOT_FOUND.s': 'Откройте ссылку сами и убедитесь, что pass загружается\nСкопируйте ссылку из адресной строки браузера, пока pass открыт\nЕсли вы только что его создали, подождите минуту и отправьте снова',
  'rbxi.GAMEPASS_PRICE_MISMATCH.t': 'Цена pass не совпадает с вашим заказом',
  'rbxi.GAMEPASS_PRICE_MISMATCH.d': 'Цена game pass должна быть ровно такой, как указано выше, — а не суммой, которую вы получите.',
  'rbxi.GAMEPASS_PRICE_MISMATCH.s': 'Откройте ваш game pass → Configure → Sales\nУстановите цену ровно такой, как указано выше\nСохраните и отправьте ссылку снова',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.t': 'Для этого pass включены региональные цены',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.d': 'Roblox показывает разную цену в разных странах, поэтому pass нельзя купить за фиксированную сумму.',
  'rbxi.REGIONAL_PRICING_NOT_SUPPORTED.s': 'Откройте ваш game pass → Configure → Sales\nОтключите Regional Pricing\nСохраните и отправьте ссылку снова',
  'rbxi.GAMEPASS_SELLER_MISMATCH.t': 'Этот pass принадлежит другому аккаунту',
  'rbxi.GAMEPASS_SELLER_MISMATCH.d': 'Game pass должен быть создан на том же аккаунте Roblox, который получит Robux.',
  'rbxi.GAMEPASS_SELLER_MISMATCH.s': 'Создайте pass на аккаунте, который получит Robux\nОтправьте новую ссылку',
  'rbxi.UNIVERSE_NOT_FOUND.t': 'Не удалось прочитать игру, к которой относится pass',
  'rbxi.UNIVERSE_NOT_FOUND.d': 'Pass должен принадлежать публичной игре.',
  'rbxi.UNIVERSE_NOT_FOUND.s': 'Откройте вашу игру → Configure → убедитесь, что она Public\nЗатем отправьте ссылку снова',
  'rbxi.ROBLOX_USER_NOT_FOUND.t': 'Мы не нашли этот аккаунт Roblox',
  'rbxi.ROBLOX_USER_NOT_FOUND.d': 'Проверьте написание имени пользователя или отправьте вместо него ссылку на game pass.',
  'rbxi.ROBLOX_USER_NOT_FOUND.s': 'Отправьте ссылку на game pass — она сама определяет ваш аккаунт',
  'rbxi.OUT_OF_STOCK.t': 'Ваш заказ в очереди',
  'rbxi.OUT_OF_STOCK.d': 'Запас Robux пополняется, ваш заказ зарезервирован. Он завершится автоматически, как только появится запас, — делать ничего не нужно.',
  'rbxi.ROBLOX_DAILY_LIMIT.t': 'Достигнут дневной лимит Roblox',
  'rbxi.ROBLOX_DAILY_LIMIT.d': 'Roblox ограничивает, сколько можно отправить на один аккаунт в день. Заказ возобновится автоматически после сброса лимита.',
  'rbxi.INSUFFICIENT_FUNDS.t': 'Ваш заказ в очереди',
  'rbxi.INSUFFICIENT_FUNDS.d': 'Ваш заказ зарезервирован и скоро будет выполнен. От вас ничего не требуется.',
  'rbxi.ORDER_ALREADY_EXISTS.t': 'Этот заказ уже выполняется',
  'rbxi.ORDER_ALREADY_EXISTS.d': 'Ваш game pass уже у нас — отправлять его снова не нужно.',
};

export default ru;
